import { useTranslation } from 'react-i18next';
import { FlaskConical } from 'lucide-react';
import { useDemoPersistGuard } from '../hooks/useDemoPersistGuard';

export default function DriverDemoBanner() {
  const { t } = useTranslation();
  const { isDemoDriver } = useDemoPersistGuard();
  if (!isDemoDriver) return null;

  return (
    <div
      role="status"
      className="bg-amber-50 border-b border-amber-200 text-amber-950 px-4 py-3"
    >
      <div className="max-w-4xl mx-auto flex items-start gap-2.5">
        <FlaskConical size={20} className="shrink-0 text-amber-700 mt-0.5" aria-hidden />
        <div>
          <p className="font-semibold text-sm">{t('driverDemo.bannerTitle')}</p>
          <p className="text-xs text-amber-900/90 mt-0.5">{t('driverDemo.bannerBody')}</p>
        </div>
      </div>
    </div>
  );
}
